import { render } from "./DailyUpdateTicker.vue?vue&type=template&id=8adb2a48&scoped=true"
import script from "./DailyUpdateTicker.vue?vue&type=script&lang=js"
export * from "./DailyUpdateTicker.vue?vue&type=script&lang=js"

import "./DailyUpdateTicker.vue?vue&type=style&index=0&id=8adb2a48&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8adb2a48"]])

export default __exports__